var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCalendar = function SvgIconCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M8.04 2c-.6 0-.96.448-.96 1v1H6C4.44 4 3 5.343 3 7v12c0 1.657 1.44 3 3 3h12c1.68 0 3-1.343 3-3V7c0-1.657-1.32-3-3-3h-.96V3c0-.552-.48-1-1.08-1-.48 0-.96.448-.96 1v1H9V3c0-.552-.36-1-.96-1m7.92 4H6c-.48 0-.96.448-.96 1v1h13.92V7c0-.552-.36-1-.96-1zM5.04 19v-9h13.92v9c0 .552-.36 1-.96 1H6c-.48 0-.96-.448-.96-1m2.04-6c0-.552.36-1 .96-1h2.04c.48 0 .96.448.96 1v2c0 .552-.48 1-.96 1H8.04c-.6 0-.96-.448-.96-1z",
    clipRule: "evenodd"
  })));
};
export default SvgIconCalendar;